'use client';
import dynamic from 'next/dynamic';

import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import TechnologyFaq from '@/components/technologies/technology-faq';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import ReactFAQ from '@/components/faqs/react-faq';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import ReactJsDevelopment from '@/components/technologies/reactjs-development';
import ReactJsServies from '@/components/technologies/reactjs-services';
import ContentVideoSection from '@/components/common/content-video';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Transform Your Ideas into High-Performance Applications with 
Leading ReactJS Development Services."
                alt="React Js Development"
                title="React Js Development"
                width={1090}
                height={604}
                path={'react-js-developer-hero'}
                bgPath={'hero-bg-grunge'}
            >
                ReactJS Development <div>Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="React JS" />
            <ReactJsDevelopment title="Simplify and Scale Your Applications with ReactJS Development Services"></ReactJsDevelopment>
            <ReactJsServies />
            <HireProcess
                bg="bg-reactjs"
                pageTitle="Hire ReactJS Developers To Build Cutting-Edge Digital Products"
                desc="Looking to hire expert developers? Our team of skilled React developers is ready to help you build cutting-edge digital products. Outsource ReactJS development to us and take advantage of our flexible engagement models, tailored to your project needs."
                ndaText="We prioritize the security of your data by signing a non-disclosure agreement."
                discussingRequirementText="We work closely with you to understand your goals and define a clear project roadmap."
                designingText="Our team creates intuitive, user-centric designs that align with your vision."
                developmentText="We build your application with clean, efficient code, ensuring top performance."
                deploymentText="We handle the launch of your application, ensuring a smooth transition to the market."
                supportAndMaintenanceText="Our ReactJS maintenance and support services keep your application running smoothly post-deployment."
            />
            <WhyChooseUs
                pageTitle="Why Choose Moweb For ReactJS Application Development?"
                onTimeDelivery="We understand that timely delivery is critical to your success. At Moweb, we meticulously plan and execute projects to ensure they are delivered on time and within budget, without compromising quality. "
                tailoredBusinessExcellence="Our commitment to excellence means we provide custom ReactJS solutions that are specifically tailored to meet your business needs, ensuring you achieve your goals efficiently."
                technologicalExpertiseCenter="Our extensive knowledge and experience with the latest technologies, including server-side rendering (SSR) with ReactJS and cross-browser compatibility in ReactJS, enable us to address your unique challenges effectively."
                privacyCommitment="Your privacy is our top priority. We implement stringent security measures to protect your data and ensure complete confidentiality."
                specializedTechnicalTeam="Our team comprises expert ReactJS developers, designers, and engineers who are dedicated to delivering high-quality solutions that exceed your expectations."
                flexibleHiringModels="Choose from a variety of engagement models, including dedicated teams, fixed-cost projects, or time and material agreements, to find the best fit for your project."
                trustedOutsourcingPartner="As a trusted ReactJS development agency, we are committed to your success. Partner with us to experience the benefits of outsourced ReactJS development and take your business to the next level."
            />

            <ModelsOfWorking
                title="Engagement Models To Hire The Best ReactJS Developers"
                desc="Select the best engagement model to hire ReactJS developers for your specific business needs. Whether you need a dedicated team, fixed-cost project, or time and material arrangement, we offer flexible solutions that align with your requirements."
            />
            <ContentVideoSection title="Industry-Specific ReactJS Solutions for Enhanced Efficiency">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        At Moweb, we understand that each industry has its unique set of challenges and requirements. Our ReactJS
                        development services are designed to provide industry-specific solutions that cater to the distinct needs
                        of sectors such as healthcare, finance, eCommerce, and education. As a leading ReactJS development
                        company, we specialize in web and{' '}
                        <a href="mobile-app-development" target="_self" className="text-blue-400">
                            {' '}
                            mobile development services
                        </a>{' '}
                        that help you stay ahead in the market. Whether {`you're`} looking to build a secure healthcare platform,
                        a dynamic eCommerce site, or a robust financial application, our dedicated team of React developers is
                        equipped to deliver React software development services that not only meet your current development needs
                        but also prepare you for future growth.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        Our ReactJS web development company offers a comprehensive range of services, including ReactJS app
                        development, web application development, and progressive web apps built with ReactJS. We utilize React
                        developer tools and React components to ensure that your React project is powered by the latest in React
                        JavaScript technology, providing scalable and high-performance solutions.
                    </p>
                </>
            </ContentVideoSection>
            <TechnologyFaq title="FAQs On ReactJS Development Services" bg="bg-reactjs">
                <ReactFAQ />
            </TechnologyFaq>

            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
